// @flow
import React, { Component } from 'react';
import { SidebarSecondaryItemLink } from './SidebarStyles';
import { DefaultIcon } from '../../../components/Icon';

type Props = {
  to: string,
  icon: string,
  label: string,
  exact?: boolean
};

export default class SidebarSecondaryItem extends Component<Props> {
  render() {
    return (
      <SidebarSecondaryItemLink to={this.props.to} exact={this.props.exact}>
        <DefaultIcon name={this.props.icon} />
        <h5>{this.props.label}</h5>
      </SidebarSecondaryItemLink>
    );
  }
}
